<template>
  <div class="bikelist-container">
    <el-form :model="queryInfo" size="medium" :inline="true">
          <el-form-item :label="$t('bike.name188')"  prop="tenantId">
            <el-cascader ref="refHandle" v-model="tenantIds" @change="handleChange1" :show-all-levels="false" clearable collapse-tags :props="{ lazy: true, checkStrictly: true, multiple: true, lazyLoad: loadOptions }"></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('bike.name2')" prop="ebikeModelId">
            <el-input v-model="queryInfo.ebikeModelId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name31')" prop="controllerEdition">
            <el-input v-model="queryInfo.controllerEdition" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name32')" prop="meterEdition">
            <el-input v-model="queryInfo.meterEdition" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name33')" prop="iotEdition">
            <el-input v-model="queryInfo.iotEdition" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('finance.name33')" prop="ebikeId">
              <el-input v-model="queryInfo.ebikeId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name35')" prop="status">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')" clearable>
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
            <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
          </el-form-item>
    </el-form>
    <div class="add-user">
      <!-- <el-button type="primary" size="medium" @click="showModeBindDialog" v-if="buttonPerms.indexOf('ebikeModel/bindModel') > -1" >{{ $t('bike.name115') }}</el-button> -->
      <el-button type="primary" size="medium" @click="showVersionConfigurationDialog">{{ $t('tabmenu.name55') }}</el-button>
      <!-- <el-button type="primary" size="medium" @click="changeTransportMode" :loading='loading1' v-if="buttonPerms.indexOf('ebike/sendTransportInfo') > -1">{{ $t('bike.name117') }}</el-button> -->
      <!-- <el-button type="primary" size="medium" @click="showFiveCodeDialog" v-if="buttonPerms.indexOf('ebike/importEbikeVin') > -1">{{ $t('bike.name116') }}</el-button> -->
      <!-- <el-button type="primary" size="medium" @click="showAddIotNum" v-if="buttonPerms.indexOf('ebike/tenantBindEbike') > -1">分配归属</el-button> -->
      <!-- <el-button type="primary" size="medium" @click="showImportIotNum" v-if="buttonPerms.indexOf('ebike/importTenantBindEbike') > -1">导入分配归属</el-button> -->
      <!-- <el-button size="medium" type="primary" @click="showIOTDialog" v-if="buttonPerms.indexOf('ebike/importIOT') > -1">导入IOT</el-button> -->
      <!-- <el-button size="medium" type="primary" @click="exportEbikeData"  :loading='exportLoading'>导出车辆</el-button> -->
    </div>
    <el-table ref="table"   :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading" @selection-change="onSelectTab">
      <el-table-column type="selection" width="55" align="center" fixed="left" :selectable="selectable"></el-table-column>
      <el-table-column :label="$t('bike.name38')" prop="ebikeId" sortable></el-table-column>
      <el-table-column :label="$t('home.name21')" prop="tenantName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name40')" prop="mac" sortable ></el-table-column>
      <el-table-column :label="$t('bike.name43')" prop="controllerVersion" sortable></el-table-column>
      <el-table-column :label="$t('bike.name106')" prop="meterVersion" sortable></el-table-column>
      <el-table-column :label="$t('bike.name107')" prop="iotVersionNo" sortable></el-table-column>
      <el-table-column :label="$t('bike.name52')" prop="ebikeModelName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name4')" prop="ebikeModelId" sortable></el-table-column>
      <!-- <el-table-column :label="$t('bike.name108')" prop="ebikeVinNo" sortable width="200"></el-table-column> -->
      <el-table-column :label="$t('bike.name109')" prop="motorNo" sortable></el-table-column>
      <el-table-column :label="$t('bike.name110')" prop="remark" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name111')" prop="isTransport" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.isTransport === 0 ? $t('bike.name251') : $t('bike.name252') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name112')" prop="status" sortable>
        <template slot-scope="scope">
          <div class="green" v-if="scope.row.status === 1">
            <div class="text">{{ $t('bike.name45') }}</div>
          </div>
          <div class="red" v-if="scope.row.status === 0">
            <div class="text">{{ $t('bike.name113') }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name44')" prop="test" sortable>
        <template slot-scope="scope">
          {{ [$t('bike.name251'),$t('bike.name252')][scope.row.isTest] }}
          <!-- <el-switch class="switch" :value="scope.row.isTest" :active-value="1"  :inactive-value="0" active-color="#0f73e6" inactive-color="#dcdfe6"   :active-text="$t('bike.name252')"  :inactive-text="$t('bike.name251')"> </el-switch> -->
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('bike.name11')" width="140px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="showDetailsDialog(scope.row)" v-if="buttonPerms.indexOf('ebike/findEbikeDetail') > -1">{{ $t('bike.name46') }}</el-button>
          <el-button type="text" @click="showIotDetailsDialog(scope.row)" v-if="buttonPerms.indexOf('ebike/getIotDetalis') > -1">IOT</el-button>
          <el-button type="text" @click="handleCancelBindModel(scope.row)" v-if="buttonPerms.indexOf('ebikeModel/cancelBindModel') > -1">{{ $t('bike.name114') }}</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!--车型绑定-->
    <el-dialog :title="$t('bike.name120')" :visible.sync="vehicleModelBindingDialog" v-if="vehicleModelBindingDialog" :close-on-click-modal ="false" :before-close="close" width="600px">
      <el-form ref="bindingFormRef" label-width="120px" :model="bindingForm" :rules="bindingFormRules">
        <el-form-item :label="$t('bike.name2')" prop="ebikeModelId">
           <el-select v-model="bindingForm.ebikeModelId" :placeholder="$t('public.name1')">
              <el-option v-for="item in modelOptions" :key="item.ebikeModelId" :label="item.ebikeModelId" :value="item.ebikeModelId"> </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bindingVehicleMode" :loading='loading'>{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

      <!--分配运营商-->
    <el-dialog title="分配运营商" :visible.sync="assignOperatorsDialog" v-if="assignOperatorsDialog" :close-on-click-modal ="false" :before-close="close" width="600px" >
      <el-form ref="assignOperatorsFormRef" label-width="120px" :model="assignOperatorsForm"   :rules="assignOperatorsFormRules">
        <el-form-item label="运营商名称：" prop="tenantId">
          <el-select v-model="assignOperatorsForm.tenantId" :placeholder="$t('public.name1')">
              <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAssignOperators" :loading='loading2'>{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

      <!--导入IOT-->
      <el-dialog :title="$t('bike.name158')" :visible.sync="iotDialog" v-if="iotDialog" :close-on-click-modal ="false" :before-close="close" width="600px" >
      <el-form ref="iotFormRef" label-width="150px" >
        <el-form-item :label="$t('bike.name100')">
          <a href="https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5IOT%E6%A8%A1%E7%89%88.xlsx">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name102')" prop="fiveWayCodeFile" style="width:100%;">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile3" :loading='loading2'>{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

     <!--版本配置-->
     <el-dialog :title="$t('bike.name118')" :visible.sync="versionConfigurationDialog" v-if="versionConfigurationDialog" :close-on-click-modal ="false" :before-close="close" width="600px">
      <el-form ref="versionConfigurationFormRef" label-width="120px" :model="versionConfigurationForm"  :rules="versionConfigurationFormRules">
        <el-form-item :label="$t('bike.name445')" prop="tenantName">
            {{ versionConfigurationForm.tenantName }}
          </el-form-item>
          <el-form-item :label="$t('bike.name2')" prop="tenantName">
            {{ versionConfigurationForm.ebikeModelId }}
          </el-form-item>
        <el-form-item :label="$t('bike.name20')" prop="hardwareType">
            <el-select v-model="versionConfigurationForm.hardwareType" :placeholder="$t('public.name1')" @change="changeType">
              <el-option v-for="item in typeOptions" :key="item.name" :label="item.label" :value="item.name"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('bike.name18')" prop="otaFirewareInfoId">
            <el-select v-model="versionConfigurationForm.otaFirewareInfoId" :placeholder="$t('public.name1')">
              <el-option v-for="item in versionNumberOptions" :key="item.name" :label="item.fileName" :value="item.name"> </el-option>
            </el-select>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitVersionConfiguration" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

      <!--导入五通码-->
      <el-dialog title="五通码上传" :visible.sync="fiveWayCodeUploadDialog" v-if="fiveWayCodeUploadDialog" :close-on-click-modal ="false" :before-close="close" width="600px">
      <el-form label-width="150px">
        <el-form-item label="五通码模板下载：">
          <a href="https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BA%94%E9%80%9A%E7%A0%81EXCEL%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx?Expires=2365230403&OSSAccessKeyId=ULZah0Yxq41iLeaf&Signature=gstHMnwITJS8aCNBItkF%2BYpURqQ%3D">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item label="五通码EXCEL上传：">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile1" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

    <!--导入分配归属-->
    <el-dialog :title="$t('bike.name157')" :visible.sync="importIotNumDialog" v-if="importIotNumDialog" :close-on-click-modal ="false" :before-close="close" width="600px">
      <el-form label-width="150px" ref="importBelongFormRef"  :rules="importBelongFormRules"  :model="importBelong">
        <el-form-item :label="$t('bike.name100')">
          <a href="https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5IOT%E6%A8%A1%E7%89%88.xlsx">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name160')" prop="tenantId">
          <el-cascader v-model="importBelong.tenantId" :show-all-levels="false" @change="handleChange" :props="{ lazy: true, checkStrictly: true, lazyLoad: loadOptions }" clearable></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('bike.name102')" >
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile2" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

    <!--分配归属-->
    <el-dialog :title="$t('bike.name156')" :visible.sync="addIotNumDialog" v-if="addIotNumDialog" :close-on-click-modal ="false" :before-close="close" width="600px">
      <el-form ref="belongFormRef"  label-width="150px" :rules="belongFormRules"  :model="belong">
        <el-form-item :label="$t('bike.name160')"  prop="tenantId">
            <el-cascader v-model="belong.tenantId" :show-all-levels="false" @change="handleChange" :props="{ lazy: true, checkStrictly: true, lazyLoad: loadOptions }" clearable></el-cascader>
        </el-form-item>

        <!-- <el-form-item :label="$t('bike.name98')">
          <el-input v-model="queryInfo.loginName" :placeholder="$t('public.name5')" clearable> </el-input>
        </el-form-item> -->

        <!-- <el-form-item :label="$t('bike.name99')">
          <el-switch
            v-model="queryInfo.status"
            active-color="#0f73e6"
            inactive-color="#dcdfe6"
            active-value="1"
            inactive-value="0"
            :active-text="$t('bike.name45')"
            :inactive-text="$t('bike.name104')"
          >
          </el-switch>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitBelong" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

     <!--车辆详情-->
     <el-dialog title="车辆详情" :visible.sync="eBikeDetailsDialog" v-if="eBikeDetailsDialog" :before-close="close" width="60%">
      <div class="top">
        <div>{{ eBikeDetails.ebikeId }}</div>
        <div><el-button type="text" @click="showBaseInfoDialog">修改基础信息</el-button></div>
      </div>

      <div class="title-style">
        <el-divider></el-divider>
        <div class="title">车辆基本信息</div>
        <el-divider></el-divider>
      </div>

      <el-form label-width="120px" style="width:100%;">
        <el-row>
          <el-col :span="8"><el-form-item label="车辆编码：">{{ eBikeDetails.ebikeCode }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="IOT编号：">{{ eBikeDetails.ebikeId }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="车辆mac：">{{ eBikeDetails.mac }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item label="入库时间：">{{ eBikeDetails.storageTime }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="轨迹时间：">{{ eBikeDetails.gisTime }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="心跳时间：">{{ eBikeDetails.keepliveTime }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item label="经度：">{{ eBikeDetails.lng }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="纬度：">{{ eBikeDetails.lat }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="高度：">{{ eBikeDetails.alt }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item label="速度：">{{ eBikeDetails.speed }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="电量：">{{ eBikeDetails.soc }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="车锁的状态：">{{ eBikeDetails.lockStatus === 0 ? '解锁状态' : '锁车状态' }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item label="状态：">{{ eBikeDetails.status === 0 ? '故障' : '正常' }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="备注：">{{ eBikeDetails.remark }}</el-form-item></el-col>
        </el-row>
      </el-form>
      <div class="title-style">
        <el-divider></el-divider>
        <div class="title">车辆报警信息</div>
        <el-divider></el-divider>
      </div>
      <el-table :data="alarmMessageList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }">
      <el-table-column label="发生时间" prop="changeTime"  > </el-table-column>
      <el-table-column label="报警状态" prop="state" >
        <template slot-scope="scope">
          <div>{{ scope.row.state === 1 ? '已变化' : '未变化' }}</div>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleAlarmSizeChange"
      @current-change="handleAlarmCurrentChange"
      :current-page="pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="alarmTotal"
    >
    </el-pagination>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="close">确定</el-button> -->
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

      <!--修改车辆基本信息-->
      <el-dialog title="修改车辆基本信息" :visible.sync="eBikeBaseInfoDialog" v-if="eBikeBaseInfoDialog" :close-on-click-modal ="false" :before-close="closeBaseInfoDialog" width="600px">
        <el-form label-width="120px" style="width:100%;" :model="eBikeBaseInfo">
          <!-- <el-form-item label="web配置：">
            <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="eBikeBaseInfo.webConfiguration">
          </el-input>
        </el-form-item> -->
        <el-form-item label="备注：">
            <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="eBikeBaseInfo.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handlerDelBike" :loading="loading3" v-if="userinfo.tenantType === 0">删除车辆</el-button>
        <el-button type="primary" @click="handlerModify" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBaseInfoDialog">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

      <!--IOT详情-->
      <el-dialog title="IOT详情" :visible.sync="iotDetailsDialog" v-if="iotDetailsDialog" :close-on-click-modal ="false" :before-close="close" width="60%">
      <div class="top">
        <div>{{ ebikeId }}</div>
      </div>

      <div class="title-style">
        <el-divider></el-divider>
        <div class="title">IOT基本信息</div>
        <el-divider></el-divider>
      </div>

      <el-form label-width="180px" style="width:100%;">
        <el-row>
          <el-col :span="8"><el-form-item label="认证用户名：">{{ iotDetails.username }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="连接状态：">{{ iotDetails.connected }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="端口：">{{ iotDetails.port }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item label="节点：">{{ iotDetails.node }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="IP地址：">{{ iotDetails.ip_address }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="心跳：">{{ iotDetails.keepalive }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item label="会话创建时间：">{{ iotDetails.created_at }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="会话过期时间：">{{ iotDetails.expiry_interval }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="连接时间：">{{ iotDetails.connected_at }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item label="发送报文数：">{{ iotDetails.send_pkt }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="接收报文数：">{{ iotDetails.recv_pkt }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="接收的报文数量：">{{ iotDetails.recv_cnt }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item label="最大未确认的数据包计数：">{{ iotDetails.max_awaiting_rel }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item label="最大飞行窗口：">{{ iotDetails.max_inflight }}</el-form-item></el-col>
        </el-row>
      </el-form>
      <div class="title-style">
        <el-divider></el-divider>
        <div class="title">IOT订阅的主题</div>
        <el-divider></el-divider>
      </div>
      <el-table :data="subscribeList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }">
      <el-table-column label="node" prop="node"  > </el-table-column>
      <el-table-column label="clientid" prop="clientid" ></el-table-column>
      <el-table-column label="qos" prop="qos" ></el-table-column>
      <el-table-column label="topic" prop="topic" ></el-table-column>
    </el-table>
    <div class="title-style">
        <el-divider></el-divider>
        <div class="title">iot日志</div>
        <el-divider></el-divider>
      </div>
      <div class='date-picker'>
        <el-date-picker
            v-model="searchTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
          >
          </el-date-picker>
        <el-button type="primary" size="small" @click="getIotLog" class="search-bt" :loading="loading">查询</el-button>
      </div>
      <div style="margin:15px;" v-html="iotLogInfo"></div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="modelFormtrue">确定</el-button> -->
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import Cookies from 'js-cookie'
import { findEbikeBatchUpgradePage, bindModel, cancelBindModel, findEbikeDetail, getEbikePosture, sendTransportInfo, tenantBindEbike, importEbikeVin, importTenantBindEbike, importEbikeIdMacNoTenantId, modifyEbikeBaseInfo, findOtaFirmwarePage, findEbikeModelPage, otaFirmwareInfoList2, otaFirmwareInfoList3, sendUpgradeInfo, findIotStatusInfo, findIotSubscribeTopic, findIotCmdLog, exportEbike, removeIotEbike } from '@/api/bike.js'
import { tenantList } from '@/api/manage.js'
import { downloadExcel } from '@/utils/utils'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      tenantAll: [],
      tenantIds: '',
      searchTime: null,
      iotDetailsDialog: false,
      eBikeBaseInfoDialog: false,
      iotDialog: false,
      eBikeBaseInfo: {
        ebikeId: '',
        remark: ''
      },
      typeOptions: [],
      typeAllOptions: [
        { name: 0, label: 'IOT' },
        { name: 1, label: '控制器' },
        { name: 2, label: '仪表' }
      ],
      loading1: false,
      loading2: false,
      loading3: false,
      exportLoading: false,
      pageNumber: 1,
      pageSize: 10,
      alarmTotal: 0,
      alarmMessageList: [],
      subscribeList: [],
      importIotNumDialog: false,
      assignOperatorsDialog: false,
      versionConfigurationDialog: false,
      fiveWayCodeUploadDialog: false,
      eBikeDetailsDialog: false,
      eBikeDetails: {},
      iotDetails: {},
      addIotNumDialog: false,
      vehicleModelBindingDialog: false,
      tenantOptions: [],
      modelOptions: [],
      bindingForm: {
        ebikeModelId: '',
        ebikeIdList: []
        // ebikeVinNo: ''
      },
      fileList: [],
      belong: {
        tenantId: []
      },
      belongFormRules: {
        tenantId: [
          {
            required: true,
            message: '请选择任意一级',
            trigger: 'blur'
          }
        ]
      },
      importBelong: {
        tenantId: []
      },
      importBelongFormRules: {
        tenantId: [
          {
            required: true,
            message: '请选择任意一级',
            trigger: 'blur'
          }
        ]
      },
      statusOptions: [
        {
          value: '1',
          label: '正常'
        },
        {
          value: '0',
          label: '故障'
        }
      ],
      bindingFormRules: {
        ebikeModelId: [
          {
            required: true,
            message: '请输入车型编号',
            trigger: 'blur'
          }
        ]
      },
      assignOperatorsForm: {
        tenantId: ''
      },
      assignOperatorsFormRules: {
        tenantId: [
          {
            required: true,
            message: '请选择运营商',
            trigger: 'blur'
          }
        ]
      },
      versionConfigurationForm: {
        hardwareType: '',
        otaFirewareInfoId: '',
        ebikeIdList: [],
        tenantId: '',
        tenantName: '',
        ebikeModelId: ''
      },
      versionConfigurationFormRules: {
        otaFirewareInfoId: [
          {
            required: true,
            message: '请选择版本号',
            trigger: 'blur'
          }
        ],
        hardwareType: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'blur'
          }
        ]
      },
      queryInfo: {
        status: '',
        pageNumber: 1,
        pageSize: 10,
        ebikeId: '',
        controllerEdition: '',
        meterEdition: '',
        iotEdition: '',
        permTenantList: [],
        ebikeModelId: ''
      },
      tableLoading: false,
      loading: false,
      selectionList: [],
      total: 0,
      tableList: [],
      options: [],
      ridelist: [
        {
          bikeCode: '',
          email: '',
          remark: '',
          ebikeId: '',
          type: '',
          bikeMac: '',
          status: '',
          isTransport: '',
          controllerEdition: '',
          meterEdition: '',
          iotEdition: '',
          ebikeModelId: '',
          ebikeModelName: '',
          motorNo: '',
          ebikeVinNo: ''
        }
      ],
      isTransportlist: [],

      // 详情提示框
      ebikeId: '',
      dialogBikeInfoVisible: false,
      IOTebikeId: '',
      dialogIoTisible: false,
      // 延迟
      // 车型绑定
      modelist: [],
      modelVisible: false,
      modelFrom: {
        ebikeModelId: '',
        ebikeId: [],
        ebikeVinNo: ''
      },
      modelFromRules: {
        ebikeModelId: [
          {
            required: true,
            message: '请填写车型编号',
            trigger: 'blur'
          }
        ]
      },
      // OTA升级
      selectlist: [],
      disposeOTAVisible: false,
      disposeOTAFrom: {
        ebikeId: [],
        hardwareType: '',
        versionNumber: ''
      },
      versionNumberOptions: [],
      TypefirmwareList: [],
      fiveWayCodeFile: null,
      ImportbikeVisible: false,
      buttonPerms: '',
      tenantAllOptions: [],
      iotLogInfo: ''
    }
  },
  components: {},
  created() {
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  mounted() {
    this.getTenantList()
    this.getEbikeModelList()
    // this.getOtaFirmwareInfoLlist2()
  },
  methods: {
    resetQuery() {
      this.queryInfo.status = ''
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      this.queryInfo.ebikeId = ''
      this.queryInfo.controllerEdition = ''
      this.queryInfo.meterEdition = ''
      this.queryInfo.iotEdition = ''
      this.queryInfo.ebikeModelId = ''
      this.queryInfo.permTenantList = []
      this.tenantIds = []
      this.getBikeList()
    },
    exportEbikeData() {
      this.exportLoading = true
      this.queryInfo.ebikeId = this.queryInfo.ebikeId.trim()
      this.queryInfo.controllerEdition = this.queryInfo.controllerEdition.trim()
      this.queryInfo.meterEdition = this.queryInfo.meterEdition.trim()
      this.queryInfo.iotEdition = this.queryInfo.iotEdition.trim()
      exportEbike(this.queryInfo).then(res => {
        this.exportLoading = false
        downloadExcel(res, '车辆信息')
      }).catch(() => {
        this.exportLoading = false
      })
    },
    getEbikeModelList() {
      const queryInfo = {
        pageNumber: 1,
        pageSize: 500
      }
      findEbikeModelPage(queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.modelOptions = res.data.ebikeModelPage.records
        }
      })
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2
      }
      tenantList(data)
        .then(res => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    showImportIotNum() {
      this.importIotNumDialog = true
    },
    selectable(row, index) {
      if (row.ebikeModelId) {
        return true
      } else {
        return false
      }
    },
    showAddIotNum() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择车辆')
        return
      }
      this.addIotNumDialog = true
    },
    showAssignOperatorsDialog() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择车辆')
        return
      }
      this.assignOperatorsDialog = true
    },
    showVersionConfigurationDialog() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择车辆')
        return
      }
      const manufacturerIdList = []
      const ebikeModelIdList = []
      this.selectionList.map((item) => {
        if (item.ebikeModelId !== null) {
          ebikeModelIdList.push(item.ebikeModelId)
        }
        manufacturerIdList.push(item.manufacturerId)
      })
      var isShow1 = this.areAllElementsSame(manufacturerIdList)
      var isShow2 = this.areAllElementsSame(ebikeModelIdList)
      if (isShow1 && isShow2 && ebikeModelIdList.length > 0) {
        this.versionConfigurationForm.tenantId = this.selectionList[0].manufacturerId
        this.versionConfigurationForm.tenantName = this.selectionList[0].manufacturerName
        this.versionConfigurationForm.ebikeModelId = this.selectionList[0].ebikeModelId
        this.getOtaFirmwareInfoLlist2()
        this.versionConfigurationDialog = true
      } else {
        this.$message.warning('请选择同一厂商和同一车型编号的数据')
      }
    },
    areAllElementsSame(array) {
      if (array.length <= 1) {
        return true
      }
      for (let index = 1; index < array.length; index++) {
        if (array[index] !== array[index - 1]) {
          return false
        }
      }
      return true
    },
    showFiveCodeDialog() {
      this.fiveWayCodeUploadDialog = true
    },
    showDetailsDialog(row) {
      this.eBikeBaseInfo.ebikeId = row.ebikeId
      getEbikePosture({ ebikeId: row.ebikeId, pageSize: this.pageSize, pageNumber: this.pageNumber }).then(res => {
        if (res.code === 200) {
          this.alarmMessageList = res.data.ebikePosturePage.records
          this.alarmTotal = res.data.ebikePosturePage.total
        }
      })

      findEbikeDetail({ ebikeId: row.ebikeId }).then(res => {
        if (res.code === 200) {
          this.eBikeDetails = res.data.iotEbike
          this.eBikeDetailsDialog = true
        }
      })
    },
    showBaseInfoDialog() {
      this.eBikeBaseInfoDialog = true
    },
    handlerDelBike() {
      this.$confirm('是否删除该车辆?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeIotEbike({ ebikeId: this.eBikeBaseInfo.ebikeId }).then((res) => {
            if (res.code === 200) {
              this.closeBaseInfoDialog()
              this.eBikeDetailsDialog = false
              this.getPageList()
              this.$message({ type: 'success', message: '删除成功!' })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handlerModify() {
      this.loading3 = true
      modifyEbikeBaseInfo(this.eBikeBaseInfo)
        .then((res) => {
          this.loading3 = false
          if (res.code === 200) {
            findEbikeDetail({ ebikeId: this.eBikeBaseInfo.ebikeId }).then((res) => {
              if (res.code === 200) {
                this.eBikeDetails = res.data.iotEbike
              }
            })
            this.closeBaseInfoDialog()
          }
        })
        .catch(() => {
          this.loading3 = false
        })
    },
    closeBaseInfoDialog() {
      this.eBikeBaseInfoDialog = false
      this.eBikeBaseInfo = {
        ebikeId: '',
        remark: ''
      }
      // this.pageSize = 10
      // this.pageNumber = 1
      // this.alarmTotal = 0
      // this.alarmMessageList = []
    },
    showIotDetailsDialog(row) {
      this.iotDetailsDialog = true
      this.ebikeId = row.ebikeId
      findIotStatusInfo({ ebikeId: row.ebikeId })
        .then((res) => {
          if (res.code === 200) {
            if (res.data.iotStatusInfo.length > 0) {
              this.iotDetails = res.data.iotStatusInfo[0]
            }
          }
        })
        .catch(() => {
        })
      findIotSubscribeTopic({ ebikeId: row.ebikeId })
        .then((res) => {
          if (res.code === 200) {
            this.subscribeList = res.data.topic
          }
        })
        .catch(() => {
          this.subscribeList = []
        })
    },
    submitVersionConfiguration() {
      this.$refs.versionConfigurationFormRef.validate((valid) => {
        if (valid) {
          this.loading2 = true
          this.versionConfigurationForm.ebikeIdList = []
          this.versionConfigurationForm.tenantId = this.queryInfo.tenantId
          this.selectionList.map((item, index) => {
            this.versionConfigurationForm.ebikeIdList.push(item.ebikeId)
          })
          sendUpgradeInfo(this.versionConfigurationForm)
            .then((res) => {
              this.loading2 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.close()
                this.getBikeList()
              }
            })
            .catch(() => {
              this.loading2 = false
            })
        } else {
          return false
        }
      })
    },
    submitAssignOperators() {
      this.$refs.assignOperatorsFormRef.validate(valid => {
        if (valid) {
          this.loading2 = true
          const ebikeIdList = []
          this.selectionList.map((item, index) => {
            ebikeIdList.push(item.ebikeId)
          })
          tenantBindEbike({ ebikeIdList: ebikeIdList, tenantId: this.assignOperatorsForm.tenantId })
            .then(res => {
              this.loading2 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.close()
                this.getBikeList()
              }
            })
            .catch(() => {
              this.loading2 = false
            })
        } else {
          return false
        }
      })
    },
    submitBelong() {
      this.$refs.belongFormRef.validate((valid) => {
        if (valid) {
          this.$confirm('是否确定提交?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.loading2 = true
              const ebikeIdList = []
              this.selectionList.map((item, index) => {
                ebikeIdList.push(item.ebikeId)
              })
              tenantBindEbike({ ebikeIdList: ebikeIdList, tenantId: this.belong.tenantId })
                .then((res) => {
                  this.loading2 = false
                  if (res.code === 200) {
                    this.$refs.table.clearSelection()
                    this.close()
                    this.getBikeList()
                  }
                })
                .catch(() => {
                  this.loading2 = false
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              })
            })
        } else {
          return false
        }
      })
    },
    changeTransportMode() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择车辆')
        return
      }
      if (this.selectionList.length > 1) {
        this.$message.warning('最多选择一辆车辆')
        return
      }
      const ebikeIdList = []
      this.selectionList.map((item, index) => {
        ebikeIdList.push(item.ebikeId)
      })
      this.$confirm('此操作将改变运输模式,是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading1 = true
          sendTransportInfo({ ebikeId: ebikeIdList[0] })
            .then(res => {
              this.loading1 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.getBikeList()
              }
            })
            .catch(() => {
              this.loading1 = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    close() {
      this.vehicleModelBindingDialog = false
      this.assignOperatorsDialog = false
      this.assignOperatorsForm = {
        tenantId: ''
      }
      this.versionConfigurationDialog = false
      this.fiveWayCodeUploadDialog = false
      this.eBikeDetailsDialog = false
      this.bindingForm = {
        ebikeModelId: '',
        ebikeIdList: []
      }
      this.importIotNumDialog = false
      this.addIotNumDialog = false
      this.belong = {
        tenantId: ''
      }
      this.importBelong = {
        tenantId: ''
      }
      this.versionConfigurationForm.hardwareType = ''
      this.versionConfigurationForm.otaFirewareInfoId = ''
      this.versionConfigurationForm.ebikeIdList = []
      this.versionConfigurationForm.tenantId = ''
      this.versionConfigurationDialog = false
      this.searchTime = null
      this.iotLogInfo = ''
      this.iotDetailsDialog = false
      this.iotDialog = false
    },
    getPageList() {
      this.queryInfo.pageSize = 10
      this.queryInfo.pageNumber = 1
      this.getBikeList()
    },

    getBikeList() {
      this.tableLoading = true
      this.queryInfo.ebikeId = this.queryInfo.ebikeId.trim()
      this.queryInfo.controllerEdition = this.queryInfo.controllerEdition.trim()
      this.queryInfo.meterEdition = this.queryInfo.meterEdition.trim()
      this.queryInfo.iotEdition = this.queryInfo.iotEdition.trim()
      this.queryInfo.ebikeModelId = this.queryInfo.ebikeModelId.trim()
      findEbikeBatchUpgradePage(this.queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.tableList = res.data.page.records
          this.total = res.data.page.total
        }
      }).catch(() => {
        this.tableLoading = false
      })
    },
    showModeBindDialog() {
      if (this.selectionList.length > 0) {
        this.selectionList.map((item, index) => {
          this.bindingForm.ebikeIdList.push(item.ebikeId)
        })
        this.vehicleModelBindingDialog = true
      } else {
        this.$message.warning('请选择车辆')
      }
    },
    bindingVehicleMode() {
      this.$refs.bindingFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          bindModel(this.bindingForm).then(res => {
            this.loading = false
            // console.log('===', res.code)
            if (res.code === 200) {
              this.getBikeList()
              this.$refs.table.clearSelection()
              this.close()
            }
          }).catch(() => {
            this.loading = false
          })
          this.close()
        } else {
          return false
        }
      })
    },
    handleCancelBindModel(row) {
      this.$confirm('是否解绑车型?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          cancelBindModel({ ebikeIdList: [row.ebikeId] }).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '解绑成功!'
              })
              this.queryInfo.pageNumber = 1
              this.getBikeList()
            }
          }).catch(() => {})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解绑'
          })
        })
    },
    onSelectTab(selection) {
      this.selectionList = selection
    },
    loadOptions(node, resolve) {
      // console.log('===', node)
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 3,
          parentId: node.value
        }
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 2
            }))
            resolve(options)
          } else {
            resolve([])
          }
          if (node.level === 0) {
            // this.versionConfigurationForm.tenantName = res.data.list[0].tenantName
            this.getPageList()
            // this.getOtaFirmwareInfoLlist2()
          }
        })
        .catch(() => {})
    },
    versionLoadOptions(node, resolve) {
      console.log('====', node)
      let data = {
        pageNumber: 1,
        pageSize: 500
      }
      if (node.level === 1) {
        data = {
          pageNumber: 1,
          pageSize: 500,
          tenantId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          pageNumber: 1,
          pageSize: 500,
          parentId: node.value
        }
      }
      findOtaFirmwarePage(data).then((res) => {
        var options = []
        if (node.level === 0) {
          options = res.data.page.records.map((item) => ({ value: item.tenantId, label: item.tenantName, leaf: node.level >= 2 }))
        }
        if (node.level === 1) {
          options = res.data.page.records.map((item) => ({ value: item.firmwareType, label: ['IOT', '控制器', '仪表'][item.firmwareType], leaf: node.level >= 2 }))
        }
        resolve(options)
      }).catch(() => {})
    },
    handleVersionChange(value) {},
    handleChange(value) {
      console.log('value===', value)
      // 处理选项变化
      this.belong.tenantId = value[value.length - 1]
      this.importBelong.tenantId = value[value.length - 1]
      this.$nextTick(() => {
        const dom = document.getElementsByClassName('el-radio is-checked')[0]
        const brother = dom.nextElementSibling
        brother.click()
      })
    },
    handleChange1(value) {
      // 处理选项变化
      this.queryInfo.permTenantList = []
      if (value.length > 0) {
        value.map((item) => {
          this.queryInfo.permTenantList.push(item[item.length - 1])
        })
      }
      // const panelRefs = this.$refs.refHandle.$refs.panel
      // if (panelRefs.activePath.length !== 0) {
      //   panelRefs.activePath.forEach(item => {
      //     if (item.children.length === 0) {
      //       panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      //     }
      //   })
      // }
      this.getPageList()
      // this.getOtaFirmwareInfoLlist2()
    },
    handleUpLoadFile(param) {
      const formData = new FormData()
      formData.append('file', param.file)
      const loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      importEbikeIdMacNoTenantId(formData)
        .then(res => {
          loading.close()
          downloadExcel(res, '导入IOT信息')
          this.getBikeList()
        })
        .catch(res => {
          loading.close()
        })
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getBikeList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.getBikeList()
    },
    // 监听pagesizes的事件
    handleAlarmSizeChange(newSize) {
      this.pageSize = newSize
      getEbikePosture({ ebikeId: this.eBikeBaseInfo.ebikeId, pageSize: this.pageSize, pageNumber: this.pageNumber }).then(res => {
        if (res.code === 200) {
          this.alarmMessageList = res.data.ebikePosturePage.records
          this.alarmTotal = res.data.ebikePosturePage.total
        }
      })
      // this.getBikeList()
    },
    // 监听页码值改变事件
    handleAlarmCurrentChange(newPage) {
      this.pageNumber = newPage
      // this.getBikeList()
      getEbikePosture({ ebikeId: this.eBikeBaseInfo.ebikeId, pageSize: this.pageSize, pageNumber: this.pageNumber }).then(res => {
        if (res.code === 200) {
          this.alarmMessageList = res.data.ebikePosturePage.records
          this.alarmTotal = res.data.ebikePosturePage.total
        }
      })
    },

    // 导入五通码
    Importbike() {
      this.ImportbikeVisible = true
    },
    ImportbikeDialogBefore() {
      this.ImportbikeVisible = false
    },
    uploadFile(file) {
      this.fiveWayCodeFile = file
    },
    delFile() {
      this.fiveWayCodeFile = null
    },
    handleBeforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('上传的文件大小不能超过10MB!')
        return false
      }
      return true
    },
    handleManualUpload() {
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      this.fiveWayCodeFile = e.target.files[0]
      e.target.value = ''
      // let obj = new Object()
      // obj.name = e.target.files[0].name
      // obj.url = e.target.files[0].name
      // this.fileList = [{}]
      // console.log('e===', e.target.files[0])
    },
    uploadSectionFile1() {
      if (this.fiveWayCodeFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      this.loading2 = true
      importEbikeVin(formData)
        .then(res => {
          this.loading2 = false
          // if (res.code === 200) {
          downloadExcel(res, '五通码导入信息')
          this.$refs.table.clearSelection()
          this.getBikeList()
          this.fiveWayCodeUploadDialog = false
          this.fiveWayCodeFile = null

          // }
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    uploadSectionFile2() {
      if (this.fiveWayCodeFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.importBelong.tenantId)
      this.loading2 = true
      importTenantBindEbike(formData)
        .then(res => {
          this.loading2 = false
          // if (res.code === 200) {
          downloadExcel(res, '导入IOT信息')
          this.$refs.table.clearSelection()
          this.getBikeList()
          this.importIotNumDialog = false
          this.importBelong.tenantId = ''
          this.fiveWayCodeFile = null

          // }
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    showIOTDialog() {
      this.iotDialog = true
    },
    uploadSectionFile3() {
      if (this.fiveWayCodeFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      this.loading2 = true
      importEbikeIdMacNoTenantId(formData)
        .then(res => {
          this.loading2 = false
          // if (res.code === 200) {
          downloadExcel(res, '导入IOT信息')
          this.getBikeList()
          this.iotDialog = false
          this.fiveWayCodeFile = null

          // }
        })
        .catch(res => {
          this.loading2 = false
        })
    },

    blobDownload(data) {
      if (!data) {
        return
      }
      const name = '五通码检验结果'
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(data, name)
      } else {
        const blob = new Blob([data.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        URL.revokeObjectURL(url)
      }
    },
    onUploadSuccess() {
      this.$message.success('文件上传成功，请查看下载结果')
      this.$refs.uploadss.clearFiles()
      this.ImportbikeVisible = false
      this.getBikes()
    },
    beforebikeupload(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (size > 50) {
        this.$message.warning('文件大小不得超过50M')
        return false
      }
      if (extension !== 'xlsx') {
        this.$message.warning('只能上传后缀是.xlsx的文件')
        return false
      }
    },
    getOtaFirmwareInfoLlist2() {
      this.typeOptions = []
      const data = {
        tenantId: this.versionConfigurationForm.tenantId,
        ebikeModelId: this.versionConfigurationForm.ebikeModelId
      }
      otaFirmwareInfoList2(data)
        .then((res) => {
          res.data.map((item) => {
            this.typeAllOptions.map((items) => {
              if (item === items.name) {
                const obj = {}
                obj.name = items.name
                obj.label = items.label
                this.typeOptions.push(obj)
              }
            })
          })
        })
        .catch(() => {
          this.typeOptions = []
        })
    },
    changeType(e) {
      const data = {
        tenantId: this.versionConfigurationForm.tenantId,
        ebikeModelId: this.versionConfigurationForm.ebikeModelId,
        firmwareType: e
      }
      otaFirmwareInfoList3(data)
        .then((res) => {
          this.versionNumberOptions = res.data
        })
        .catch(() => {
          this.versionNumberOptions = []
        })
    },
    getIotLog() {
      if (this.searchTime) {
        this.loading = true
        findIotCmdLog({ startTime: this.searchTime[0], endTime: this.searchTime[1], ebikeId: this.ebikeId, wrap: '</br>' }).then((res) => {
          if (res.data.iotLogInfo) {
            this.iotLogInfo = res.data.iotLogInfo
          } else {
            this.iotLogInfo = '暂无数据'
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>
<style lang="scss">
.switch .el-switch__label {
  position: absolute;
  display: none;
  color: #fff !important;
}

/*打开时文字位置设置*/
.switch .el-switch__label--right {
  z-index: 1;
}

/* 调整打开时文字的显示位子 */
.switch .el-switch__label--right span {
  margin-left: 9px;
}

/*关闭时文字位置设置*/
.switch .el-switch__label--left {
  z-index: 1;
}

/* 调整关闭时文字的显示位子 */
.switch .el-switch__label--left span {
  margin-left: 22px;
}

/*显示文字*/
.switch .el-switch__label.is-active {
  display: block;
}

/* 调整按钮的宽度 */
.switch.el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 60px !important;
  margin: 0;
}

</style>

<style lang="scss" scoped>
.bikelist-container {
  display: flex;
  flex-direction: column;
  .top{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .add-user{
    display: flex;
    flex-direction: row;
  }

  .title-style{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title{
      width: 50%;
      text-align: center;
    }
  }

  .date-picker{
    display: flex;
    flex-direction: row;
   .search-bt{
      margin-left: 25px;
    }
  }

  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }

  .green {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;
  }

  .red {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;
  }
}
</style>
